export default __webpack_public_path__ + "static/media/ElonMusk.e9df8672.jpg";